import dayjs from 'dayjs';
import { TransportItem } from './transport-item.model';
import { Transporter } from './transporter.model';
import { InsuranceItem } from './insurance-item.model';
import { IBasket } from './basket.model';
import { ITransportExtraCondition } from './transport-extra-condition.model';
import { Civility } from './enums/civility.enum';
import { QuotationStatusEnum } from './enums/quotation-status.enum';
import { ItemConditionEnum } from './enums/item-condition.enum';
import { TransportTypology } from './enums/transport-typology.enum';
import { OfferServiceTypeEnum } from './enums/offer-service-type.enum';
import { OptionsTypeSelector } from './options-type-selector';
import { ServiceType } from './offer-service-type.model';
import { MerchandiseType } from './offer-merchandise-type.model';
import { AccessConstraintEnum } from './enums/access-constraint.enum';
import { LoadingConstraintEnum } from './enums/loading-constraint.enum';
import { TransportStep } from './enums/transport-step.enum';

export abstract class AbstractTransport {
  public id?: number;
  public itemsNature?: string;
  public goodsValue?: number;
  public euroPallet?: number;
  public pickupAddressFullname?: string;
  public pickupAddressStreetNumber?: string;
  public pickupAddressStreet?: string;
  public pickupAddressZipCode?: string;
  public pickupAddressCity?: string;
  public pickupAddressCountry?: string;
  public pickupAddressAdditionals?: string;
  public pickupAddressInseeCode?: string;
  public pickupContactCivility?: Civility;
  public pickupContactFirstName?: string;
  public pickupContactLastName?: string;
  public pickupContactMail?: string;
  public pickupContactPhone?: string;
  public pickupReference?: string;
  public pickupDate?: dayjs.Dayjs;
  public pickupLoadingConstraint: LoadingConstraintEnum = LoadingConstraintEnum.NONE;
  public pickupAccessConstraint: AccessConstraintEnum = AccessConstraintEnum.NONE;
  public pickupMeeting?: boolean;
  public pickupFloor?: number;
  public pickupTimeslotStart?: number;
  public pickupTimeslotEnd?: number;
  public pickupRegisteredAddressId?: number;
  public pickupComments?: string;
  public pickupPhoneCall?: boolean;
  public deliveryAddressFullname?: string;
  public deliveryAddressStreetNumber?: string;
  public deliveryAddressStreet?: string;
  public deliveryAddressZipCode?: string;
  public deliveryAddressCity?: string;
  public deliveryAddressCountry?: string;
  public deliveryAddressAdditionals?: string;
  public deliveryContactCivility?: Civility;
  public deliveryContactFirstName?: string;
  public deliveryContactLastName?: string;
  public deliveryContactMail?: string;
  public deliveryContactPhone?: string;
  public deliveryReference?: string;
  public deliveryDate?: dayjs.Dayjs;
  public deliveryMaxDate?: dayjs.Dayjs;
  public deliveryMeeting?: boolean;
  public deliveryLoadingConstraint: LoadingConstraintEnum = LoadingConstraintEnum.NONE;
  public deliveryAccessConstraint: AccessConstraintEnum = AccessConstraintEnum.NONE;
  public deliveryAddressInseeCode?: string;
  public deliveryComments?: string;
  public deliveryTimeslotStart?: number;
  public deliveryTimeslotEnd?: number;
  public deliveryRegisteredAddressId?: number;
  public deliveryFloor?: number;
  public deliveryPhoneCall?: boolean;
  public totalPallets?: number;
  public totalParcel?: number;
  public billingQuantity?: number;
  public totalVolume?: number;
  public totalWeight?: number;
  public totalLDM?: number;
  public distance?: number;
  public outsideEuDeliveryCountry?: string;
  public outsideEuDeliveryCity?: string;
  public outsideEuDeliveryComments?: string;
  public offerId?: number;
  public creationDate?: dayjs.Dayjs;
  public creatorLogin?: string;
  public itemsCondition?: ItemConditionEnum;
  public items: TransportItem[] = [];
  public transporter?: Transporter;
  public insuranceItem?: InsuranceItem;
  public basket?: IBasket;
  public transportExtraConditions: ITransportExtraCondition[] = [];
  public customerId?: number;
  public offerName?: string;

  public merchandiseType!: MerchandiseType;
  public serviceType!: ServiceType;
  public isControlledTemperature: boolean = false;
  public isHazardousMaterial: boolean = false;
  public pickupAddressGpsCoords?: string;
  public deliveryAddressGpsCoords?: string;

  public quotationValidityDate?: dayjs.Dayjs; //TODO: A mettre dans l'obj quotationView
  public quotationStatus?: QuotationStatusEnum; //TODO: A mettre dans l'obj quotationView
  public quotationBasePrice?: number; //TODO: A mettre dans l'obj quotationView
  public quotationPriceHT?: number; //TODO: A mettre dans l'obj quotationView
  public quotationRejectionMessage?: string; //TODO: A mettre dans l'obj quotationView

  public creatorUuid?: string;
  public orderTunnelStep?: TransportStep;

  public getOptionsTypeSelector(): OptionsTypeSelector {
    if (this.isHazardousMaterial) {
      return OptionsTypeSelector.TYPE_HAZARDOUS_MATERIAL;
    }
    if (this.isControlledTemperature) {
      return OptionsTypeSelector.TYPE_CONTROLLED_TEMPERATURE;
    }
    return OptionsTypeSelector.TYPE_MARCHANDISES_GENERALES;
  }

  // @deprecated temporaire afin de ne pas supprimer completement la notion de transportTypologie
  public get transportTypology(): TransportTypology {
    if (this.isHazardousMaterial) {
      return TransportTypology.HAZARDOUS_MATERIAL;
    }
    if (this.isControlledTemperature) {
      return TransportTypology.CONTROLLED_TEMPERATURE;
    }
    return TransportTypology.GENERAL_GOODS;
  }

  public isFTL(): boolean {
    return this.serviceType.code === OfferServiceTypeEnum.FTL;
  }
}
